module.exports = __webpack_public_path__ + "img/NWS014-Silk-Top-Hair-System-with-Injected-Skin-and-Lace-Front-2-300x300.04442c1a.jpg";